import React, { useContext } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { FaCalendar, FaUser, FaEye, FaArrowLeft, FaWhatsapp, FaEnvelope, FaTwitter, FaLinkedin } from 'react-icons/fa';
import { AppContext } from '../App';

const BlogDetail = () => {
  const { slug } = useParams();
//   const { blogs, setBlogs } = useContext(AppContext);
const { blogs } = useContext(AppContext);
  const blog = blogs.find(b => b.slug === slug);

  if (!blog) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-primary mb-4">Blog Not Found</h2>
          <Link to="/blogs" className="btn-primary">Back to Blogs</Link>
        </div>
      </div>
    );
  }

  const shareText = `Check out this article: ${blog.title} - Wisdom Consultancy`;
  const shareUrl = window.location.href;

  return (
    <>
      <Helmet>
        <title>{blog.title} | Wisdom Consultancy Blog</title>
        <meta name="description" content={blog.excerpt} />
      </Helmet>

      <div className="bg-gray-50 py-12">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            {/* Back Button */}
            <Link to="/blogs" className="inline-flex items-center gap-2 text-primary hover:gap-3 transition-all mb-6">
              <FaArrowLeft /> Back to Blogs
            </Link>

            {/* Blog Header */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="bg-white rounded-2xl shadow-xl overflow-hidden"
            >
              {blog.image && (
                <img src={blog.image} alt={blog.title} className="w-full h-80 object-cover" />
              )}

              <div className="p-8">
                <div className="flex flex-wrap items-center gap-4 text-sm text-gray-500 mb-4">
                  <span className="flex items-center gap-2"><FaCalendar /> {blog.createdAt}</span>
                  <span className="flex items-center gap-2"><FaUser /> {blog.author}</span>
                  <span className="flex items-center gap-2"><FaEye /> {blog.views} views</span>
                </div>

                <h1 className="text-3xl md:text-4xl font-bold text-primary mb-4">{blog.title}</h1>

                <div className="flex flex-wrap gap-2 mb-6">
                  {blog.tags?.map((tag, idx) => (
                    <span key={idx} className="text-xs bg-gray-100 text-gray-600 px-3 py-1 rounded-full">#{tag}</span>
                  ))}
                </div>

                <div className="border-t pt-6">
                  <div dangerouslySetInnerHTML={{ __html: blog.content }} className="prose max-w-none" />
                </div>

                {/* Share Section */}
                <div className="border-t pt-6 mt-8">
                  <h3 className="font-bold text-lg mb-4">Share this article</h3>
                  <div className="flex gap-3">
                    <a href={`https://wa.me/?text=${encodeURIComponent(shareText + ' ' + shareUrl)}`} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-green-500 text-white rounded-full flex items-center justify-center hover:scale-110 transition-transform">
                      <FaWhatsapp />
                    </a>
                    <a href={`mailto:?subject=${encodeURIComponent(blog.title)}&body=${encodeURIComponent(shareText + '\n\n' + shareUrl)}`} className="w-10 h-10 bg-red-500 text-white rounded-full flex items-center justify-center hover:scale-110 transition-transform">
                      <FaEnvelope />
                    </a>
                    <a href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-blue-400 text-white rounded-full flex items-center justify-center hover:scale-110 transition-transform">
                      <FaTwitter />
                    </a>
                    <a href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(blog.title)}`} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-blue-700 text-white rounded-full flex items-center justify-center hover:scale-110 transition-transform">
                      <FaLinkedin />
                    </a>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Consultation CTA */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              className="mt-12 bg-gradient-to-r from-primary to-secondary rounded-2xl p-8 text-center text-white"
            >
              <h3 className="text-2xl font-bold mb-3">Need Expert Financial Advice?</h3>
              <p className="mb-4 opacity-90">Get personalized guidance from our financial experts</p>
              <Link to="/contact" className="bg-accent px-6 py-2 rounded-lg font-semibold hover:bg-opacity-90 transition-all inline-block">
                Schedule Consultation
              </Link>
            </motion.div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogDetail;